import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryProducts } from '@wix/ambassador-stores-catalog-v3-product/http';
import { RequestedFields } from '@wix/ambassador-stores-catalog-v3-product/types';
export const fetchProductV3 = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkProducts = [];
      let cursor = null;
      let hasNext = true;
      do {
        var _result$data$pagingMe, _result$data$pagingMe2;
        const result = await httpClient.request(queryProducts({
          fields: [RequestedFields.MEDIA_ITEMS_INFO, RequestedFields.URL],
          query: {
            cursorPaging: {
              cursor,
              limit: COMMON_PAGE_LIMIT
            },
            filter: idChunk.length > 0 ? {
              id: {
                $in: idChunk
              }
            } : undefined
          }
        }));
        chunkProducts.push(...(result.data.products ?? []));
        hasNext = ((_result$data$pagingMe = result.data.pagingMetadata) == null ? void 0 : _result$data$pagingMe.hasNext) ?? false;
        cursor = ((_result$data$pagingMe2 = result.data.pagingMetadata) == null || (_result$data$pagingMe2 = _result$data$pagingMe2.cursors) == null ? void 0 : _result$data$pagingMe2.next) ?? null;
      } while (hasNext);
      return chunkProducts;
    });
    const results = await Promise.all(chunkPromises);
    return results.flat();
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-products-v3.js.map